const extractData = (res) => {
  const { data: { result } } = res;
  return result;
};

export {
  extractData,
};
